import { useTheme } from "@mui/material";

export default function MagnifyingGlassIcon() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  if (isDark) {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3178_2019)">
          <path
            d="M12.6039 9.64489L15.387 12.428C16.2036 13.2446 16.2036 14.5707 15.387 15.3873C14.5704 16.2038 13.2443 16.2038 12.4277 15.3873L9.64461 12.6042C9.5118 12.4713 9.5118 12.2558 9.64461 12.123L12.1225 9.64509C12.2553 9.51228 12.4709 9.51228 12.6037 9.64509L12.6039 9.64489Z"
            fill="#EB6087"
          />
          <path
            d="M6.87447 1.86708C8.21208 1.86708 9.46943 2.38791 10.4152 3.3337C11.361 4.2795 11.8819 5.53685 11.8819 6.87446C11.8819 8.21207 11.361 9.46942 10.4152 10.4152C9.46943 11.361 8.21208 11.8818 6.87447 11.8818C5.53687 11.8818 4.27952 11.361 3.33372 10.4152C2.38792 9.46942 1.86709 8.21207 1.86709 6.87446C1.86709 5.53685 2.38792 4.2795 3.33372 3.3337C4.27952 2.38791 5.53687 1.86708 6.87447 1.86708ZM6.87447 0C5.11524 0 3.35573 0.671033 2.01367 2.01338C-0.671019 4.69806 -0.671019 9.05058 2.01367 11.7353C3.35601 13.0776 5.11524 13.7486 6.87447 13.7486C8.6337 13.7486 10.3932 13.0776 11.7353 11.7353C14.42 9.05058 14.42 4.69806 11.7353 2.01338C10.3929 0.671033 8.6337 0 6.87447 0Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_3178_2019">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6039 9.64489L15.387 12.428C16.2036 13.2446 16.2036 14.5707 15.387 15.3873C14.5704 16.2038 13.2443 16.2038 12.4277 15.3873L9.64461 12.6042C9.5118 12.4713 9.5118 12.2558 9.64461 12.123L12.1225 9.64509C12.2553 9.51228 12.4709 9.51228 12.6037 9.64509L12.6039 9.64489Z"
        fill="#D51A4E"
      />
      <path
        d="M6.87444 1.86708C8.21205 1.86708 9.4694 2.38791 10.4152 3.3337C11.361 4.2795 11.8818 5.53685 11.8818 6.87446C11.8818 8.21207 11.361 9.46942 10.4152 10.4152C9.4694 11.361 8.21205 11.8818 6.87444 11.8818C5.53684 11.8818 4.27949 11.361 3.33369 10.4152C2.38789 9.46942 1.86706 8.21207 1.86706 6.87446C1.86706 5.53685 2.38789 4.2795 3.33369 3.3337C4.27949 2.38791 5.53684 1.86708 6.87444 1.86708ZM6.87444 0C5.11521 0 3.3557 0.671033 2.01364 2.01338C-0.67105 4.69806 -0.67105 9.05058 2.01364 11.7353C3.35598 13.0776 5.11521 13.7486 6.87444 13.7486C8.63367 13.7486 10.3932 13.0776 11.7352 11.7353C14.4199 9.05058 14.4199 4.69806 11.7352 2.01338C10.3929 0.671033 8.63367 0 6.87444 0Z"
        fill="#181A46"
      />
    </svg>
  );
}
